import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "link-alt",
  "use": "link-alt-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"link-alt\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.8 7.6a3 3 0 0 0 4.524.324l1.8-1.8a3 3 0 0 0-4.242-4.242L6.85 2.908\" /><path d=\"M8.2 6.4a3 3 0 0 0-4.524-.324l-1.8 1.8a3 3 0 0 0 4.242 4.242l1.026-1.026\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol